import { ContactUsEmailModelBase } from './contact-us-email.model.base';

export class ContactUsEmailModel extends ContactUsEmailModelBase {
    constructor() {
        super();
        this.type = 'development';
        //this is not translated on purpose, we use english as communication language
        this.subject = 'We need web development';
    }
}
